import(/* webpackMode: "eager" */ "/opt/build/repo/apps/hestia/src/app/rewards/page.tsx");
